import Backbone from 'backbone';

const Answer = Backbone.Model.extend({});

export default Answer;
